/** Event */
export default {
  create: '作成中',
  createProgramme: 'AI企画作成',
  aiProgramme: 'AI企画',
  name: '活動名',
  placeholder: '活動名を入力してください',
  total: '総登録数',
  likes: '総いいね数',
  income: '総登録収入',
  tips: {
    total: '申込者数にはキャンセルは含まれていません',
    income: '収入には返金、報酬、商品販売は含まれていません'
  },
  table: {
    name: '活動名',
    status: '活動状態',
    total: '総登録数',
    today: '本日の登録数',
    last_week: '先週の登録数',
    create: '作成日時',
    update: '更新日時',
    start: '開始日時',
    end: '終了日時',
    operate: '操作',
    oper: {
      data: '登録データ',
      config: 'コンテンツ設定',
      progress: '進行状況設定',
      display: '活動展示',
      screen: 'データ画面',
      share: '活動共有',
      more: 'その他の機能',
      mores: {
        setting: '表示設定',
        ad: '広告設定',
        live: '画像ライブ配信',
        video: 'ビデオハイライト',
        qrcode: 'サインインQRコード',
        gift: 'ギフトと賞品'
      }
    },
    total_number: '合計{total}件'
  },
  create_form: {
    placeholder: '入力してください',
    status: {
      '是否确认立刻发布活动?': '活動をすぐに公開しますか？'
    },
    content: {
      title: '活動内容',
      name: {
        label: '活動名',
        hover: 'この活動の名前、例：第一回子供絵画展'
      },
      cycle: {
        label: '活動サイクル',
        hover: '活動全体の期間、開始から終了まで：例：2024.01.20～2024.05.20。決まっていない場合は、予想される期間を入力してください'
      },
      stage: {
        title: '活動ステージ',
        desc: '現在は1つのフェーズのみ作成できます。さらに追加するには、初期設定を完了してから、活動リストの「詳細設定」を使用してください。',
        name: {
          title: 'フェーズ名',
          hover: '活動ステージの名前。現在、1つのステージのみ設定可能です。例：一次選考、二次選考、予選、決勝など'
        },
        start: {
          title: '登録期間',
          hover: 'このステージの登録開始時間と終了時間、分秒まで正確に入力してください。注意：登録期間外は登録できません。決まっていない場合は、後で入力できます'
        },
        hold: {
          title: '開催期間',
          hover: 'このステージの開始時間と終了時間、分秒まで正確に入力してください。例：オフライン展示期間または授賞式期間。決まっていない場合は、後で入力できます'
        }
      },
      poster: {
        title: '活動ポスター',
        upload: 'クリックしてアップロード',
        tips: {
          _1: 'ヒント：.jpg、.png画像形式をサポートしています。最大画像容量は5MBを超えることはできません。画像サイズ比は1:1に近いほど良く、最小サイズは860px×860pxです',
          _2: '画像は申込者のページ上部に表示されます。凡例を表示するにはクリックしてください'
        }
      },
      detail: {
        desc: '登録者に表示されます。凡例を表示するにはクリックしてください',
        placeholder: '入力してください',
        title: {
          _1: '活動紹介',
          _2: '登録ルール',
          _3: '組織'
        }
      }
    },
    group: {
      title: 'グループ情報',
      desc: '現在、1つのグループ活動のみ設定できます。複数の異なるグループ活動がある場合は、活動の初期作成を完了してから、活動リストの「活動設定-サブコンペティション設定」をクリックして設定してください。活動システムでは、異なるグループ活動に対して異なる登録料、登録フォーム、基本選考、登録フォームなどの設定をサポートしています',
      category: {
        title: '活動カテゴリ',
        hover: '例：アート、ダンスなど',
        add: 'カテゴリを追加',
        name: 'カテゴリ名'
      },
      group: {
        title: '活動グループ',
        hover: '例：青年グループ、大人グループなど',
        add: 'グループを追加',
        name: 'グループ名'
      },
      form: {
        title: '登録フォーム',
        hover: '登録者が入力する必要がある情報内容。異なるカテゴリやグループでは異なる登録フォームを使用できます',
        create: '活動登録情報を作成'
      },
      charge: {
        title: '登録料',
        hover: '異なるカテゴリやグループには異なる料金を設定できます'
      },
      config: {
        title: '詳細設定：',
        hover: '異なるカテゴリやグループに対して、異なる選考ルール、選考基準、選考方法、選考数、選考結果発表時間などを設定できます',
        repeat: {
          title: '同一グループの複数登録：',
          hover: 'グループ活動でユーザーが同じ情報で複数回登録することを許可するかどうか',
          default: '無効'
        },
        pass: {
          title: '登録審査合格：',
          hover: 'ユーザーが登録を提出した後、システムがデフォルトで審査して登録が有効/無効かどうかを判断するかどうか',
          default: '自動合格',
          prepay: '先に審査、後に支払い',
          postpay: '先に支払い、後に審査'
        },
        show: {
          title: '登録センター表示：',
          hover: '個人：一人の情報を入力する登録。「チーム」：複数の人の情報で構成された登録で、作品を共有',
          default: '表示'
        },
        form: {
          title: 'グループ登録フォーム：',
          hover: '個人：一人の情報を入力する登録。「チーム」：複数の人の情報で構成された登録で、作品を共有',
          default: '個人',
          team: 'チーム',
          min: '最小チームサイズ：',
          max: '最大チームサイズ：'
        },
        base: {
          title: '基本評価機能：',
          hover: '基本評価機能を有効にするかどうか。例：有効または無効',
          default: '無効'
        },
        commission: {
          title: 'パートナー手数料：',
          hover: '主催者の下位チャネルとして、パートナーが登録料の手数料率を設定',
          default: '無効'
        },
        inherit: {
          title: '選考番号の継承：',
          hover: 'メインメニューの高度な選考管理で、登録作品の選考番号を設定でき、次のラウンドに進む際に番号を継承できます',
          default: '無効'
        }
      }
    },
    session: {
      title: 'セッション情報',
      desc: 'ヒント：現在のセッション作成は、前のステップで作成されたグループ活動にのみ関連付けられています。複数のグループ活動がセッション配置を持つ場合は、活動の初期作成を完了し、活動管理に入り、「活動設定-サブコンペティション設定-セッション設定」をクリックして設定してください。単一のグループで複数のセッションを作成でき、異なるグループで異なるセッションを作成することもできます。',
      name: 'グループ活動',
      number: {
        title: '登録者',
        hover: '単一セッションの登録者数を設定します。複数のセッションがある場合、各セッションの参加者数を個別に設定する必要があります',
        config: '設定',
        default: '無制限'
      },
      arrange: {
        title: 'セッション配置',
        hover: '関連するセッション配置が決定していない場合は無効にできます。セッション配置がある場合は、オンラインとオフラインをサポートする設定を有効にできます',
        default: '無効'
      },
      form: 'セッション形式：',
      online: 'オンラインアドレス',
      offline: '地域選択',
      address: '詳細住所',
      time: 'セッション時間'
    }
  }
}



// WEBPACK FOOTER //
// ./src/langs/ja/activity.js